import { PaymentStatusReservation, paymentStatusMappings } from '@/common/enums/paymentStatus';
import { ColumnsDef } from './bag-reservation-list-table/bag-reservation-list-table.component';
import { Status, statusMappings } from '@/common/enums/Status';
import { BagReservationListFilters, FilterDefinition, ParseFilters, PaymentKinds } from './bag-reservation-list.model';

export const RESERVATION_LIST_COLUMS_DEF: ColumnsDef[] = [
	{ col: 'id', name: 'Numer', size: '80', extraStyle: { flex: '1 auto', minWidth: '80px', maxWidth: '80px' } },
	{
		col: 'statusName',
		name: `Status`,
		size: '150',
		extraStyle: { flex: '1 auto', minWidth: '150px', maxWidth: '150px' },
	},
	{
		col: 'confirmationTime',
		name: 'Data potwierdzenia',
		size: '100',
		extraStyle: { flex: '1 auto', minWidth: '100px', maxWidth: '100px' },
	},
	{
		col: 'reservationTime',
		name: 'Data utworzenia',
		size: '100',
		extraStyle: { flex: '1 auto', minWidth: '100px', maxWidth: '100px' },
	},
	{
		col: 'expirationTime',
		name: 'Czas opcji',
		size: '100',
		extraStyle: { flex: '1 auto', minWidth: '100px', maxWidth: '100px' },
	},
	{
		col: 'canceledAt',
		name: 'Data anulacji',
		size: '100',
		extraStyle: { flex: '1 auto', minWidth: '100px', maxWidth: '100px' },
	},
	{ col: 'productName', name: 'Produkt', size: '440', extraStyle: { flex: '1 auto', width: '100px' } },
	{
		col: 'destination',
		name: 'Destynacja',
		size: '100',
		extraStyle: { flex: '1 auto', minWidth: '100px', maxWidth: '100px' },
	},
	{
		col: 'departureTime',
		name: 'Wyjazd',
		size: '100',
		extraStyle: { flex: '1 auto', minWidth: '100px', maxWidth: '100px' },
	},
	{
		col: 'returnTime',
		name: 'Powrót',
		size: '100',
		extraStyle: { flex: '1 auto', minWidth: '100px', maxWidth: '100px' },
	},
	{
		col: 'seasonName',
		name: 'Sezon',
		size: '150',
		extraStyle: { flex: '1 auto', minWidth: '150px', maxWidth: '150px' },
	},
	{
		col: 'paymentKinds',
		name: 'Rodzaj płatności',
		size: '150',
		extraStyle: { flex: '1 auto', minWidth: '150px', maxWidth: '150px' },
	},
	{ col: 'nightsStay', name: 'Il. n', size: '40' },
	{
		col: 'cities',
		name: 'Miasto',
		size: '80',
		extraStyle: { flex: '1 auto', minWidth: '80px', maxWidth: '80px' },
	},
	{
		col: 'transportTypes',
		name: 'Typ transportu',
		size: '80',
		extraStyle: { flex: '1 auto', minWidth: '80px', maxWidth: '80px' },
	},
	{
		col: 'boardName',
		name: 'Wyż.',
		size: '125',
		extraStyle: { flex: '1 auto', minWidth: '125px', maxWidth: '125px' },
	},
	{
		col: 'countPerson',
		name: 'Il. osób',
		size: '80',
		extraStyle: { flex: '1 auto', minWidth: '80px', maxWidth: '80px' },
	},
	{
		col: 'canceledSlotCount',
		name: 'Il. anulowanych osób',
		size: '80',
		extraStyle: { flex: '1 auto', minWidth: '80px', maxWidth: '80px' },
	},
	{
		col: 'totalPrice',
		name: 'Wartość',
		size: '80',
		extraStyle: { flex: '1 auto', minWidth: '80px', maxWidth: '80px' },
		disableSorting: true,
	},
	{
		col: 'promotion',
		name: 'Kat. cen',
		size: '200',
		extraStyle: { flex: '1 auto', width: '200px' },
	},
	{
		col: 'promotionValue',
		name: 'Promocja',
		size: '80',
		extraStyle: { flex: '1 auto', minWidth: '80px', maxWidth: '80px' },
		disableSorting: true,
	},
	{
		col: 'commissionValue',
		name: 'Prowizja',
		size: '80',
		extraStyle: { flex: '1 auto', minWidth: '80px', maxWidth: '80px' },
		disableSorting: true,
	},
	{
		col: 'paymentStatus',
		name: 'Status płatności',
		size: '80',
		extraStyle: { flex: '1 auto', minWidth: '120px', maxWidth: '120px' },
		disableSorting: true,
	},
	{
		col: 'paidAmount',
		name: 'Suma płatności',
		size: '80',
		extraStyle: { flex: '1 auto', minWidth: '80px', maxWidth: '80px' },
		disableSorting: true,
	},
	{
		col: 'left2pay',
		name: 'Do zapłaty',
		size: '80',
		extraStyle: { flex: '1 auto', minWidth: '80px', maxWidth: '80px' },
		disableSorting: true,
	},
	{
		col: 'ownerName',
		name: 'Właściciel',
		size: '125',
		extraStyle: { flex: '1 auto', minWidth: '125px', maxWidth: '125px' },
	},
	{ col: 'ownerPhone', name: 'Tel', size: '130', extraStyle: { flex: '1 auto', width: '130px' } },
	{ col: 'ownerEmail', name: 'Email', size: '225', extraStyle: { flex: '1 auto', width: '225px' } },
	{
		col: 'bookingSupervisor',
		name: 'Opiekun',
		size: '100',
		extraStyle: { flex: '1 auto', minWidth: '100px', maxWidth: '100px' },
	},
	{ col: 'organizationName', name: 'Organizator', size: '150', extraStyle: { flex: '1 auto', width: '150px' } },
	{
		col: 'sellerShortName',
		name: 'Agent',
		size: '150',
		extraStyle: { flex: '1 auto', width: '150px' },
	},
	{
		col: 'channelName',
		name: 'Kanał',
		size: '80',
		extraStyle: { flex: '1 auto', minWidth: '80px', maxWidth: '80px' },
	},
];

export const DEFAULT_PARAMETERS = {
	locations: [],
	products: [],
	allUsers: [],
	currency: [],
	boards: [],
	transportStops: [],
	filtersLocations: [],
	productKind: [],
	paymentStatus: [
		{
			id: PaymentStatusReservation.UNPAID,
			name: paymentStatusMappings[PaymentStatusReservation.UNPAID],
		},
		{
			id: PaymentStatusReservation.PARTIALLY_PAID,
			name: paymentStatusMappings[PaymentStatusReservation.PARTIALLY_PAID],
		},
		{
			id: PaymentStatusReservation.FULLY_PAID,
			name: paymentStatusMappings[PaymentStatusReservation.FULLY_PAID],
		},
		{
			id: PaymentStatusReservation.OVERPAID,
			name: paymentStatusMappings[PaymentStatusReservation.OVERPAID],
		},
	],
	alerts: [],
	channels: [],
	organizations: [],
	filterStatus: [
		{ id: Status.OPTION, name: statusMappings[Status.OPTION] },
		{ id: Status.CONFIRMED, name: statusMappings[Status.CONFIRMED] },
		{ id: Status.CANCELED, name: statusMappings[Status.CANCELED] },
		{ id: Status.REJECTED, name: statusMappings[Status.REJECTED] },
	],
	status: [
		{ id: 'OP', name: 'Opcja' },
		{ id: 'OK', name: 'Potwierdzona' },
		{ id: 'CC', name: 'Anulowana' },
		{ id: 'CO', name: 'Anulowany Obiekt' },
		{ id: 'CT', name: 'Anulowany Termin' },
		{ id: 'CN', name: 'Anulowana Bez Kosztowo' },
		{ id: 'CM', name: 'CM' },
		{ id: 'RR', name: 'Zrzucona' },
		{ id: 'RE', name: 'Zrzucona Opcja' },
		{ id: 'RS', name: 'Zrzucona Sprzedawca' },
		{ id: 'RC', name: 'Zrzucona Klient' },
		{ id: 'RO', name: 'Zrzucona Obiekt' },
		{ id: 'RT', name: 'Zrzucony Termin' },
		{ id: 'RP', name: 'Zrzucona Promocja' },
		{ id: 'WD', name: 'Oczekiwanie na decyzję klienta' },
	],
	services: [],
	seller_is_oskar: '',
	agencies: [],
	seasons: [],
	price_adjusted: '',
	roomTypes: [],

	paymentsKinds: [
		{
			id: 'Cash',
			name: PaymentKinds.CASH,
		},
		{
			id: 'settlement',
			name: PaymentKinds.SETTLEMENT,
		},
		{
			id: 'transfer',
			name: PaymentKinds.TRANSFER,
		},
		{ id: 'card', name: PaymentKinds.CARD },
		{
			id: 'commission',
			name: PaymentKinds.COMMISSION,
		},
		{
			id: 'PAYU',
			name: PaymentKinds.PAYU,
		},
		{
			id: 'TPAY',
			name: PaymentKinds.TPAY,
		},
		{
			id: 'reclassification',
			name: PaymentKinds.RECLASSIFICATION,
		},
		{
			id: 'voucher',
			name: PaymentKinds.VOUCHER,
		},
	],
};

export const FILTERS_DEFINITION: FilterDefinition = {
	product: { type: 'string', isArray: true },
	product_kind: { type: 'string', isArray: true },
	destination_location: { type: 'string', isArray: true },
	departure_city: { type: 'string', isArray: true },
	channel: { type: 'string', isArray: true },
	location: { type: 'string', isArray: true },
	status: { type: 'string', isArray: true },
	seller: { type: 'string', isArray: true },
	organization: { type: 'string', isArray: true },
	responsible_user: { type: 'string', isArray: true },
	alert: { type: 'string', isArray: true },
	service: { type: 'string', isArray: true },
	payment_status: { type: 'string', isArray: true },
	seller_is_oskar: { type: 'string', isArray: false },
	offer__status: { type: 'string', isArray: true },
	is_on_request: { type: 'boolean', isArray: false },
	season: { type: 'number', isArray: true },
	price_adjusted: { type: 'string', isArray: false },
	room_type: { type: 'number', isArray: true },
	single_slot_sex: { type: 'string', isArray: false },
	transport_types: { type: 'string', isArray: true },
};

export const DEFAULT_BAG_RESERVATION_FILTERS: BagReservationListFilters = {
	id: null,
	owner_name: null,
	owner_phone: null,
	departure_city: [],
	nights_min: null,
	nights_max: null,
	confirmation_time__gte: null,
	confirmation_time__lte: null,
	reservation_time__gte: null,
	reservation_time__lte: null,
	time_lower_after: null,
	time_lower_before: null,
	time_upper_after: null,
	time_upper_before: null,
	total_price_max: null,
	total_price_min: null,
	balance_max: null,
	balance_min: null,
	balance_without_commission_max: null,
	balance_without_commission_min: null,
	paid_amount_min: null,
	paid_amount_max: null,
	product: [],
	payment_status: [],
	seller: [],
	organization: [],
	channel: [],
	alert: [],
	status: [],
	product_kind: [],
	responsible_user: [],
	destination_location: [],
	location: [],
	service: [],
	seller_is_oskar: '',
	offer__status: [],
	is_on_request: null,
	season: [],
	price_adjusted: '',
	room_type: [],
	single_slot_sex: null,
	payment_kind: [],
	voucher: null,
	transport_types: [],
};

export const DEFAULT_PARSE_FILTERS: ParseFilters = {
	total_price_max: null,
	total_price_min: null,
	balance_max: null,
	balance_min: null,
	balance_without_commission_max: null,
	balance_without_commission_min: null,
	status: [],
	time_lower_before: null,
	time_upper_before: null,
	reservation_time__lte: null,
	confirmation_time__lte: null,
	time_lower_after: null,
	time_upper_after: null,
	reservation_time__gte: null,
	confirmation_time__gte: null,
	paid_amount_min: null,
	paid_amount_max: null,
	offer__status: [],
};
